import React from 'react';
import { formatLineItemType, LineItemType } from 'shared/src/domain/line-item/line-item-types';

export function LineItemTypeIndicator({ lineItemType }: { lineItemType: LineItemType }) {
  return (
    <div className="whitespace-nowrap rounded bg-gray-800 text-sm text-white px-3 py-2">
      {formatLineItemType(lineItemType)} Line Item
    </div>
  );
}
